<template>
  <div class="dropdown-status ">
    <button type="button" v-if="type" class="btn-regular secondary" :style="status" @click.stop="toggledDropdown">
      <label class="label"  :class="display['value']">{{display['label']}}</label>
      <i v-if="isShown" class="icon-chevronup"></i>
      <i v-else class="icon-chevrondown"></i>
    </button>
    <button type="button" v-else-if="display" class="btn-regular secondary" :style="status2" @click.stop="toggledDropdown">
      <label class="label"  :class="display['value']">{{display['label']}}</label>
      <i v-if="isShown" class="icon-chevronup"></i>
      <i v-else class="icon-chevrondown"></i>
    </button>
    <button type="button" v-else class="btn-regular secondary" @click.stop="toggledDropdown">
      <label class="label" :class="labelClass">{{labelDropdown}} </label>
      <i v-if="isShown" class="icon-chevronup"></i>
      <i v-else class="icon-chevrondown"></i>
    </button>
    <media :query="{minWidth: 769}">
      <div v-if="isShown" class="dropdown-status__menu" @click.stop="isShown = true">
        <div class="dropdown-status__menu__wrapper">
          <ul class="dropdown-status__menu__wrapper__sub">
            <li v-for="item in list" :key="item.id" @click.stop="select(item)"
              class="dropdown-status__menu__wrapper__sub__item" :class="{selected: item.id == selected}">
              <label-status :progress="item"/>
            </li>
          </ul>
        </div>
      </div>
    </media>
    <media :query="{maxWidth: 769}">
      <modal v-if="isShown" :title="title" @modal-close="closeDropdown">
        <template slot="content">
          <div class="dropdown-status__menu" @click.stop="isShown = true">
            <div class="dropdown-status__menu__wrapper">
              <ul class="dropdown-status__menu__wrapper__sub">
                <li v-for="item in list" :key="item.id" @click.stop="select(item)"
                  class="dropdown-status__menu__wrapper__sub__item" :class="{selected: item.id == selected}">
                  <label-status :progress="item"/>
                </li>
              </ul>
            </div>
          </div>
        </template>
      </modal>
    </media>
  </div>
</template>

<script>
import Vue from 'vue'
import Media from 'vue-media'
import Modal from '@/components/Modal'
import LabelStatus from '@/components/StatusLabel'


export default {
  name: 'adx-dropdown-status',
  components: {
    'media': Media,
    'modal': Modal,
    LabelStatus
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
    labelButton: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: false
    },
    valueDisplay: {
      required: false
    },
    type:{
      required:false
    },
    display:{
      type: Object,
      default: () => {
        return {
          label: 'LEAD',
          value: 'lead'
        }
      }
    }
  },
  data() {
    return {
      isShown: false,
      isSet: false,
      selected: null,
      labelDropdown: '',
      labelClass: '',
      firstLabelDropdown: '',
      status:{
      "display": "flex",
      "justify-content": "space-between",
      "height": "55px",
      "width": "100%"
      },
      status2:{
      "display": "flex",
      "justify-content": "space-between",
      "height": "40px",
      "width": "200px"
      }
    }
  },
  watch: {
    labelButton() {
      this.labelDropdown = this.labelButton
    },
    valueDisplay() {
      if (!this.valueDisplay) {
        this.labelDropdown = this.firstLabelDropdown
        this.isSet = false
      }
    }
  },
  mounted() {
    this.$nextTick(function() {
      Vue.$broker.$on("app-click", this.closeDropdown.bind(this))
    })
    this.labelDropdown = this.labelButton
    this.firstLabelDropdown = this.labelButton
    document.body.addEventListener('keyup', e => {
      if (e.keyCode === 27) {
        this.closeDropdown()
      }
    })
  },
  updated() {
    this.$nextTick(function() {
      Vue.$broker.$on("app-click", this.closeDropdown.bind(this))
    })
  },
  methods: {
    toggledDropdown(sender) {
      Vue.$broker.$emit("app-click", this)
      this.isShown = !this.isShown
    },
    closeDropdown(sender) {
      if (sender === this) {
        return
      }
      this.isShown = false
    },
    select(item) {
      this.$emit('selected', item)
      if (this.selected == item.id) {
        this.selected = null
        this.labelDropdown = this.firstLabelDropdown
        this.labelClass = ''
        this.isSet = false
      } else {
        this.labelDropdown = item.label
        this.labelClass = item.value
        this.selected = item.id
        this.isSet = true
      }
      this.closeDropdown()
    },
  },
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>
